export default "__VITE_ASSET__CoBo9CjH__"